import { PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const UpdateEmployeePageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.employees.update.pageHeader.title')} />
}

UpdateEmployeePageHeader.displayName = 'UpdateEmployeePageHeader'
export default UpdateEmployeePageHeader
